// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  auth0: {
    domain: 'edwardian-postcard.eu.auth0.com',
    clientId: '35APgr-QO9JtZMQGMhemSnUajy0RHIgN',
    callbackURL: 'https://www.lancaster.ac.uk/fass/projects/edwardian-postcards/home'
  },
  errors: {
    // imageBaseURL: 'http://localhost:8888/postcards/images/',
    imageBaseURL: 'https://www.lancaster.ac.uk/fass/projects/edwardian-postcards/images/',
    missingImageURL: 'https://www.lancaster.ac.uk/fass/projects/edwardian-postcards/assets/images/postcard_holder.png'
  },
  upload: {
    // url: 'http://localhost:8888/postcards/postcards-api/public/upload',
    url: 'https://www.lancaster.ac.uk/fass/projects/edwardian-postcards/postcards-api/public/upload'
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
